import { render, staticRenderFns } from "./ComponentWrapper.vue?vue&type=template&id=04c9d1ad&"
import script from "./ComponentWrapper.vue?vue&type=script&lang=ts&"
export * from "./ComponentWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports